import { render } from "./RightToWorkCheckPopup.vue?vue&type=template&id=6f85e74c&scoped=true&ts=true"
import script from "./RightToWorkCheckPopup.vue?vue&type=script&lang=ts"
export * from "./RightToWorkCheckPopup.vue?vue&type=script&lang=ts"

import "./RightToWorkCheckPopup.vue?vue&type=style&index=0&id=6f85e74c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f85e74c"]])

export default __exports__